import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when request with socket was not possible to send / receive.
 * @memberOf Playtech.API.events
 * @event socket-breakdown
 * @type {callback}
 * @param {object} detials
 * @param {number} details.reason - Main reason for error.
 * @param {number} details.requestId - Request ID.
 * @example Playtech.on('socket-breakdown', ({ reason, requestId }) => { ... });
 */
export const SOCKET_BREAKDOWN = 'socket-breakdown';

export const useOnSocketBreakdown = (eventTarget: EventTarget): void => {
    const triggerSocketBreakdownEvent = useCallback((detail: {
        reason: string;
        requestId: number;
    }) => {
        const event = new CustomEvent(SOCKET_BREAKDOWN, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('socket-breakdown', triggerSocketBreakdownEvent);

        return () => {
            publicEventsAPIService.off('socket-breakdown', triggerSocketBreakdownEvent);
        };
    }, [triggerSocketBreakdownEvent]);
};
